<template>
  <div class="tool-item">
    <div>
      <a href="javascript:void(0)" @click="iniData([])">
        <img src="../assets/attach_file.png" width="24" height="24">
      </a>
    </div>
    <el-dialog
      class="newDialog"
      title="取之不盡"
      :visible.sync="visible"
      height="100%"
      :before-close="handleClose"
    >
      <div class="brandFilter">
        <el-checkbox-group
          :min="1"
          v-model="brandList"
          @change="getTreelist"
          class="brand-checkbox"
        >
          <el-checkbox label="TutorABC">
            <img src="../assets/TutorABC.png" alt>
          </el-checkbox>
          <el-checkbox label="tutorJr" class="isJr">
            <img src="../assets/tutorJr.png" alt>
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <div class="newList touch_css">
        <div class="breadcrumb">
          <a @click="breadcrumbClick(item)" v-for="(item, index) in Breadcrumb">
            <img src="../assets/arrow-tail.svg" alt class="notLast">
            <img src="../assets/arrow-tail-l.svg" alt class="istLast">
            {{item.name}}
            <img src="../assets/arrow-head.svg" alt class="notLast">
            <img src="../assets/arrow-head-l.svg" alt class="istLast">
          </a>
        </div>
        <el-input
          id="contentfilter"
          placeholder="輸入關鍵字進行過濾"
          v-model="SearchText"
          @keyup.enter.native="contentfilter"
        ></el-input>
        <div v-show="!contentShow">
          <ul>
            <li
              :class="[item.ThumbnailUrl=== '' ? 'withoutImg' : '' ]"
              v-for="(item, index) in newoptions"
              @click="nodeClick(item)"
            >
              <div class="thumb_img" v-if="item.ThumbnailUrl!== ''">
                <img :src="item.ThumbnailUrl" alt>
              </div>
              <span>{{item.NodeName}}</span>
              <img class="hasNext" src="../assets/next.png" alt>
            </li>
          </ul>
        </div>
        <div v-show="contentShow">
          <ul class="noNext">
            <li
              :class="[item.thumbnailUrl=== '' ? 'withoutImg' : '' ]"
              v-for="(item, index) in tableData.filter(data => !search || data.filename.toLowerCase().indexOf(search.toLowerCase())>=0)"
              @click="preview(item)"
            >
              <div class="thumb_img" v-if="item.thumbnailUrl!== ''">
                <img :src="item.thumbnailUrl" alt>
              </div>
              <span>{{item.filename}}</span>
            </li>
          </ul>
        </div>
      </div>

       <div class="fileList" v-if="!fileList || !fileList.length">
        <a>asfasfasfasf</a>
      </div>


    </el-dialog>
    <el-dialog
      title="預覽"
      class="newDialog previewFile"
      :visible.sync="previewvisable"
      :before-close="handleClose"
    >
      {{selectrow.content}}
      <div v-if="selectrow.type=='Image'">
        <br>
        <br>
        <a target="_blank" :href="selectrow.path" class="imgPreview">
          <img :src="selectrow.previewImageUrl">
        </a>
      </div>
      <div v-if="selectrow.type=='File'">
        <br>
        <a :href="selectrow.path">
          <img src="../assets/file.png" width="24" height="24">
          {{selectrow.filename}}
        </a>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectFile(selectrow)">送 出</el-button>
        <el-button @click="selectFile(selectrow)">多 選a</el-button>
        <el-button @click="previewvisable = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Global from "@/components/Global";
import { AttachFileHandler } from "@/handler/AttachFileHandler.js";

export default {
  data() {
    return {
      visible: false, //附檔dialog顯示
      tableData: [], //內文檔案資料
      previewvisable: false,
      selectrow: [], //內文選擇列
      brandList: ["TutorABC", "tutorJr"], //品牌選擇
      options: [], //所有目錄結構
      newoptions: [],
      Breadcrumb: [],
      SearchText: "", //目錄搜尋值
      contentShow: false
    };
  },
  methods: {
    contentfilter(event) {
      if ($("#contentfilter").val() != this.SearchText) {
        return;
      }
      var searchNodeText = this.SearchText;
      //初始化
      this.iniData(this.brandList);

      if (searchNodeText == "") {
        return;
      }

      this.SearchNodeText = searchNodeText;
      this.tableData = AttachFileHandler.GetContentFilter(
        searchNodeText,
        this.brandList
      );

      this.contentShow = true;
    },
    iniData(brand) {
      this.visible = true;
      this.tableData = [];
      this.search = "";
      this.Breadcrumb = [];
      this.Breadcrumb.push({ name: "ROOT", value: "ROOT" });
      
      this.options = AttachFileHandler.GetContentNodeTree(brand);
      this.newoptions = this.options;
      this.contentShow = false;
      this.SearchText = "";
    },
    breadcrumbClick(node) {
      this.SearchText = "";
      let vm = this;
      vm.contentShow = false;
      vm.search = "";
      var newBreadcrumb = [];
      newBreadcrumb.push({ name: "ROOT", value: "ROOT" });

      if (node.value == "ROOT") {
        vm.newoptions = vm.options;
        vm.Breadcrumb = newBreadcrumb;
        return;
      }

      //處理導覽
      for (var i = 1; i <= vm.Breadcrumb.length - 1; i++) {
        newBreadcrumb.push(vm.Breadcrumb[i]);
        if (vm.Breadcrumb[i] === node) {
          break;
        }
      }
      vm.Breadcrumb = newBreadcrumb;

      //處理子目錄
      vm.newoptions = vm.options;
      for (var i = 1; i <= vm.Breadcrumb.length - 1; i++) {
        var filter = vm.newoptions.filter(
          data => data.NodeName == vm.Breadcrumb[i].value
        );

        if (filter.length > 0 && filter[0].Children.length > 0) {
          vm.newoptions = filter[0].Children;
        }
      }
    },
    nodeClick(item) {
      let vm = this;
      vm.Breadcrumb.push({
        name: item.NodeName,
        value: item.NodeName
      });
      var filter = vm.newoptions.filter(data => data.NodeName == item.NodeName);
      if (filter.length > 0 && filter[0].Children.length > 0) {
        vm.newoptions = filter[0].Children;
      }

      vm.tableData = [];
      vm.filecount = item.NodeName;

      vm.tableData = AttachFileHandler.GetContentByNodeId(
        item.Id,
        vm.brandList
      );
      vm.contentShow = vm.tableData.length > 0;
    },

    handleClose(done) {
      done();
    },
    selectFile(row) {
      AttachFileHandler.SendContentMessage(row.id);
      this.visible = false;
      this.previewvisable = false;
    },
    preview(row) {
      this.previewvisable = true;
      this.selectrow = row;
    },

    getTreelist(brand) {      
      this.iniData(brand);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.NodeName.indexOf(value) !== -1;
    }
  }
};
</script>
 <style>
.touch_css {
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/AttachFile.vue